import { ccpApi } from "../utils/apiClients";

// ✅ Generic function for GET requests (pagination supported)
export const apiGet = async (url, params = {}) => {
  // if (params.pageNo !== undefined) {
  //   params._page = params.pageNo;
  //   delete params.pageNo;
  // }
  // if (params.pageSize !== undefined) {
  //   params._per_page = params.pageSize;
  //   delete params.pageSize;
  // }

  const queryParams = new URLSearchParams(params).toString(); // Convert params to query string
  const response = await ccpApi.get(
    `${url}${queryParams && "?"}${queryParams}`
  ); // Append manually
  if (response?.data) {
    return response?.data;
  } else {
    return transformErrorResponse;
  }
};

// ✅ Generic function for POST requests
export const apiPost = async (url, data, headerType = "application/json") => {
  const response = await ccpApi.post(url, data, {
    headers: {
      "Content-Type": headerType, // Ensure correct headers for FormData
    },
  });
  if (response.data) {
    return response?.data;
    // let transformRes = transformPostResponse(true, response.data, null)
    // return transformRes
  } else {
    return transformErrorResponse;
  }
};

export const apiPostFormData = async (url, formData) => {
  for (let [key, value] of formData.entries()) {
    console.log(`${key}:`, value);
  }

  const response = await ccpApi.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensure correct headers for FormData
    },
  });
  if (response.data) {
    return response.data;
  } else {
    throw new Error("Failed to upload FormData");
  }
};

export const apiUpdate = async (url, data) => {
  console.log("Updating with data:", data);
  const response = await ccpApi.put(url, data); // ✅ URL now includes `id`
  if (response.data) {
    return response?.data;
    // return transformPostResponse(true, response.data, null);
  } else {
    return transformErrorResponse();
  }
};

export const apiDelete = async (url) => {
  console.log("Deleting from URL:", url);
  const response = await ccpApi.delete(url); // ✅ URL should have `id`
  if (response.status === 200 || response.status === 204) {
    return response?.data;
  } else {
    return transformErrorResponse();
  }
};

const transformResponse = (jsonData) => {
  return {
    id: null,
    isSuccess: true,
    statusCode: 200,
    info: {
      totalRecordsCount: jsonData?.items ? jsonData?.items : 0,

      totalAllRecordsCount: 0,
    },
    data: jsonData ? jsonData : [],
    errors: null,
    totalPages: 1,
  };
};

const transformErrorResponse = (
  statusCode = 400,
  errorMessage = "Sorry, Something went wrong"
) => {
  return {
    id: null,
    isSuccess: false,
    statusCode: statusCode,
    info: {
      info: null,
      stackTrace: null,
    },
    data: null,
    errors: [
      {
        statusCode: 2, // This seems to be a fixed internal status code for errors
        errorMessageEn: errorMessage,
      },
    ],
    totalPages: 0,
  };
};

const transformPostResponse = (isSuccess, data = true, errors = null) => {
  return {
    id: null,
    isSuccess,
    statusCode: isSuccess ? 200 : 400,
    info: isSuccess
      ? { totalRecordsCount: 0, totalAllRecordsCount: 0 }
      : { info: null, stackTrace: null },
    data: isSuccess ? data : null,
    errors: isSuccess ? null : errors,
    totalPages: 0,
  };
};
